// @flow
import { LARGE_VIEWPORT, MEDIUM_VIEWPORT, SMALL_VIEWPORT } from '@alphaott/app-config'
import { rgba } from 'polished'

import { colorPalette } from '../colorPalettes'
import type { ColorType } from '../colorPalettes'

export const wtvplusColors: ColorType = { ...colorPalette, primary: '#0C898A', secondary: '#0C898A' }

export const lightTheme = {
  colors: wtvplusColors,
  background: {
    primary: '#fafafa',
    secondary: '#fafafa',
    highlight: wtvplusColors.light,
    select: '#fafafa',
    footerTop: '#eee',
  },
  text: {
    primary: wtvplusColors.dark,
    secondary: wtvplusColors.grayText,
    disabled: wtvplusColors.dark,
    link: wtvplusColors.dark,
    hint: wtvplusColors.dark,
    highlight: wtvplusColors.primary,
    gray: wtvplusColors.grayText,
    seeAll: 'rgba(52, 73, 94, 0.8)',
    primaryContrast: '#ffffff',
  },
  border: {
    primary: '#dddddd',
    gray: '#ddd',
  },
  filter: {
    primary: '#43484d',
    secondary: '#43484d',
    disabled: wtvplusColors.grayLabel,
    highlight: '#fff',
  },
  tabs: {
    bg: '#fafafa',
    containerBg: wtvplusColors.dark,
    color: wtvplusColors.dark,
    border: wtvplusColors.primary,
    scrollbarThumb: wtvplusColors.primary,
    programTitle: wtvplusColors.white,
  },
  programGuide: {
    programBox: {
      background: {
        main: 'rgba(221, 221, 221, 0.8)',
        hover: wtvplusColors.dark,
        selected: wtvplusColors.dark,
        progress: rgba(wtvplusColors.primary, 0.3),
        past: rgba(wtvplusColors.primary, 0.3),
        pastSelected: wtvplusColors.dark,
        pastHover: wtvplusColors.dark,
        empty: 'rgba(221, 221, 221, 0.3)',
        emptyProgress: rgba(wtvplusColors.primary, 0.1),
      },
      text: {
        empty: wtvplusColors.grayLabel,
      },
    },
    programGuidePictureOverlay: {
      horizontal:
        // eslint-disable-next-line max-len
        `linear-gradient(90deg, #fafafa 0%,${rgba('#fafafa', 0.97)} 13.03%,${rgba('#fafafa', 0.69)} 43.24%,${rgba(
          '#fafafa',
          0,
        )} 100%);`,
      vertical: `linear-gradient(0,#fafafa 0%,${rgba('#fafafa', 0.73)} 34.97%,${rgba('#fafafa', 0)} 100%);`,
    },
  },
  card: {
    title: wtvplusColors.dark,
    subTitle: wtvplusColors.grayText,
    bg: wtvplusColors.dark,
    number: wtvplusColors.grayBorder,
    boxShadow: 'rgba(221, 221, 221, 0.8)',
    loaderBackgroundImage: 'linear-gradient(to right, #f6f7f8 0%, #edeef1 20%, #f6f7f8 40%, #f6f7f8 100%)',
  },
  dimension: {
    signLogoSize: 158,
  },
  size: 'default',
  breakpoints: [`${SMALL_VIEWPORT}px`, `${MEDIUM_VIEWPORT}px`, `${LARGE_VIEWPORT}px`],
  signIn: {
    clipPath: false,
  },
}
